import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import PortalIdParser from 'PortalIdParser';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIModal from 'UIComponents/dialog/UIModal';
import UILink from 'UIComponents/link/UILink';
import { getEmailAddressFromCurrentUserProfile, getCanSelfDelete, getIsScimUser } from '../selectors/ProfileSelector';
import SelfDeletionConfirmModal from '../components/SelfDeletionConfirmModal';
import SelfDeletionBlockedModal from '../components/SelfDeletionBlockedModal';
import UIButton from 'UIComponents/button/UIButton';
import Subsection from 'settings-ui-lib/components/Subsection';
import SettingsRowWrapper from 'settings-ui-lib/components/SettingsRowWrapper';
import { deleteSelf, removeFromAccount } from '../actions/ProfileActions';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { getDeleteSelfRequestStatus } from 'settings-ui-security/selectors/RequestStatusSelector';
import RequestStatusTypes from 'settings-ui-security/constants/RequestStatusTypes';
import { getAllSingleSuperAdminHubs } from '../selectors/UserCanGdprDeleteSelfSelector';
import { getHasRemoveFromAccountScope, isApplicationHubless } from '../selectors/AuthSelector';
import { loadCanGdprDeleteSelf } from '../actions/UserCanGdprDeleteSelfActions';
import { loadIsHubContact } from '../actions/HubContactActions';
import { getFetchUserCanGdprDeleteSelfRequestStatus, getFetchHubContactRequestStatus } from '../selectors/RequestStatusSelector';
import { getIsHubContact } from '../selectors/HubContactSelector';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const LoadingModal = ({
  onCloseModal
}) => {
  return /*#__PURE__*/_jsxs(UIModal, {
    size: "auto",
    use: "danger",
    onEsc: onCloseModal,
    children: [/*#__PURE__*/_jsx(UIDialogHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.selfDelete.modalHeader"
        })
      })
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(UILoadingSpinner, {})
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        disabled: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.selfDelete.confirmLabel"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "tertiary-light",
        onClick: onCloseModal,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.selfDelete.rejectLabel"
        })
      })]
    })]
  });
};
class SelfDeletionContainer extends Component {
  constructor(props) {
    super(props);
    this.componentDidMount = () => {
      this.loadDataToSeeIfButtonDisabled();
    };
    this.handleDeleteSelfConfirm = () => {
      const {
        modalType
      } = this.state;
      if (modalType === 'selfDelete') {
        this.props.deleteSelf();
      } else {
        this.props.removeFromAccount();
      }
    };
    this.loadDataToSeeIfButtonDisabled = () => {
      const {
        fetchUserCanGdprDeleteSelfRequestStatus,
        fetchIsHubContactRequestStatus,
        isHubless
      } = this.props;
      if (fetchUserCanGdprDeleteSelfRequestStatus === RequestStatusTypes.UNINITIALIZED) {
        this.props.loadCanGdprDeleteSelf();
      }
      if (!isHubless && fetchIsHubContactRequestStatus === RequestStatusTypes.UNINITIALIZED) {
        this.props.loadIsHubContact();
      }
    };
    this.toggleSelfDeletionConfirmModalOpen = (modalType = 'selfDelete') => {
      this.setState(state => ({
        showDeletionConfirmModal: !state.showDeletionConfirmModal,
        modalType
      }));
    };
    this.isRemoveFromAccountDisabled = () => {
      const {
        allSingleSuperAdminHubs,
        isScimUser,
        isHubContact
      } = this.props;
      return allSingleSuperAdminHubs.includes(PortalIdParser.get()) || isScimUser || isHubContact;
    };
    this.getRemoveFromAccountDisabledReason = () => {
      const {
        allSingleSuperAdminHubs,
        isScimUser
      } = this.props;
      if (isScimUser) {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "userPreferences.removeFromAccount.disabled.scimUser"
        });
      }
      if (allSingleSuperAdminHubs.includes(PortalIdParser.get())) {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "userPreferences.removeFromAccount.disabled.singleAdmin",
          options: {
            portalId: PortalIdParser.get()
          }
        });
      }
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "userPreferences.removeFromAccount.disabled.billingContact",
        options: {
          portalId: PortalIdParser.get()
        }
      });
    };
    this.getSelfDeleteDisabledReason = () => {
      const {
        allSingleSuperAdminHubs
      } = this.props;
      if (allSingleSuperAdminHubs.length === 1) {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "userPreferences.selfDelete.disabled.adminlessHubSingle",
          options: {
            portalId: allSingleSuperAdminHubs[0]
          }
        });
      }
      if (this.isRemoveFromAccountDisabled() && allSingleSuperAdminHubs.length === 0) {
        return this.getRemoveFromAccountDisabledReason();
      }
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "userPreferences.selfDelete.disabled.adminlessHubMultiple",
        options: {
          manageUsersCTA: /*#__PURE__*/_jsx(UILink, {
            onClick: () => this.toggleSelfDeletionConfirmModalOpen('selfDelete'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "userPreferences.selfDeleteBlocked.manageUsers"
            })
          })
        }
      });
    };
    this.isLoadingData = () => {
      const {
        fetchUserCanGdprDeleteSelfRequestStatus,
        fetchIsHubContactRequestStatus
      } = this.props;
      return fetchUserCanGdprDeleteSelfRequestStatus === RequestStatusTypes.PENDING || fetchIsHubContactRequestStatus === RequestStatusTypes.PENDING;
    };
    this.state = {
      showDeletionConfirmModal: false,
      selfDelete: 'selfDelete'
    };
  }
  renderMaybeConfirmModal() {
    const {
      showDeletionConfirmModal,
      modalType
    } = this.state;
    const {
      emailAddressFromProfile,
      deleteSelfRequestStatus,
      allSingleSuperAdminHubs,
      fetchUserCanGdprDeleteSelfRequestStatus
    } = this.props;
    if (!showDeletionConfirmModal) {
      return null;
    }
    if (fetchUserCanGdprDeleteSelfRequestStatus === RequestStatusTypes.PENDING) {
      return /*#__PURE__*/_jsx(LoadingModal, {
        onCloseModal: this.toggleSelfDeletionConfirmModalOpen
      });
    }
    if (allSingleSuperAdminHubs.length > 0 && modalType !== 'removeFromAccount') {
      return /*#__PURE__*/_jsx(SelfDeletionBlockedModal, {
        singleAdminHubs: allSingleSuperAdminHubs,
        onCloseModal: this.toggleSelfDeletionConfirmModalOpen
      });
    }
    return /*#__PURE__*/_jsx(SelfDeletionConfirmModal, {
      deletePending: deleteSelfRequestStatus === RequestStatusTypes.PENDING,
      deleteFailed: deleteSelfRequestStatus === RequestStatusTypes.FAILED,
      deleteSucceeded: deleteSelfRequestStatus === RequestStatusTypes.SUCCEEDED,
      emailAddress: emailAddressFromProfile,
      modalType: modalType,
      onCloseModal: this.toggleSelfDeletionConfirmModalOpen,
      onConfirmAction: this.handleDeleteSelfConfirm
    });
  }
  renderRemoveFromAccountButton() {
    const {
      isHubless
    } = this.props;
    if (isHubless) {
      return null;
    }
    return /*#__PURE__*/_jsx(Subsection, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userPreferences.removeFromAccount.title"
      }),
      children: /*#__PURE__*/_jsxs(SettingsRowWrapper, {
        children: [/*#__PURE__*/_jsx("p", {
          style: {
            maxWidth: '600px'
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "userPreferences.removeFromAccount.description"
          })
        }), /*#__PURE__*/_jsx(UITooltip, {
          title: this.getRemoveFromAccountDisabledReason(),
          disabled: !this.isRemoveFromAccountDisabled(),
          children: /*#__PURE__*/_jsx(UIButton, {
            use: "danger",
            size: "small",
            "data-test-id": "remove-user-from-account-btn",
            onClick: () => this.toggleSelfDeletionConfirmModalOpen('removeFromAccount'),
            disabled: this.isRemoveFromAccountDisabled(),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "userPreferences.removeFromAccount.linkCta"
            })
          })
        })]
      })
    });
  }
  renderSelfDeleteButton() {
    const {
      allSingleSuperAdminHubs
    } = this.props;
    return /*#__PURE__*/_jsx(Subsection, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userPreferences.selfDelete.title"
      }),
      children: /*#__PURE__*/_jsx(SettingsRowWrapper, {
        children: /*#__PURE__*/_jsx(UITooltip, {
          title: this.getSelfDeleteDisabledReason(),
          disabled: !this.isRemoveFromAccountDisabled() && allSingleSuperAdminHubs.length === 0,
          children: /*#__PURE__*/_jsx(UIButton, {
            use: "danger",
            size: "small",
            onClick: () => this.toggleSelfDeletionConfirmModalOpen('selfDelete'),
            disabled: this.isRemoveFromAccountDisabled() || allSingleSuperAdminHubs.length > 0,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "userPreferences.selfDelete.linkCta"
            })
          })
        })
      })
    });
  }
  render() {
    const {
      deleteSelfAllowed,
      hasRemoveFromAccountScope
    } = this.props;
    if (deleteSelfAllowed) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [!this.isLoadingData() ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [hasRemoveFromAccountScope ? this.renderRemoveFromAccountButton() : null, this.renderSelfDeleteButton()]
        }) : /*#__PURE__*/_jsx(UILoadingSpinner, {
          size: "small"
        }), this.renderMaybeConfirmModal()]
      });
    }
    return null;
  }
}
SelfDeletionContainer.propTypes = {
  allSingleSuperAdminHubs: PropTypes.array.isRequired,
  emailAddressFromProfile: PropTypes.string.isRequired,
  deleteSelf: PropTypes.func.isRequired,
  deleteSelfAllowed: PropTypes.bool.isRequired,
  deleteSelfRequestStatus: PropTypes.string.isRequired,
  hasRemoveFromAccountScope: PropTypes.bool.isRequired,
  loadCanGdprDeleteSelf: PropTypes.func.isRequired,
  loadIsHubContact: PropTypes.func.isRequired,
  fetchUserCanGdprDeleteSelfRequestStatus: PropTypes.string.isRequired,
  fetchIsHubContactRequestStatus: PropTypes.string.isRequired,
  isScimUser: PropTypes.bool.isRequired,
  isHubContact: PropTypes.bool.isRequired,
  isHubless: PropTypes.bool.isRequired,
  removeFromAccount: PropTypes.func.isRequired
};
const mapStateToProps = state => {
  return {
    allSingleSuperAdminHubs: getAllSingleSuperAdminHubs(state),
    emailAddressFromProfile: getEmailAddressFromCurrentUserProfile(state),
    deleteSelfAllowed: getCanSelfDelete(state),
    deleteSelfRequestStatus: getDeleteSelfRequestStatus(state),
    fetchUserCanGdprDeleteSelfRequestStatus: getFetchUserCanGdprDeleteSelfRequestStatus(state),
    fetchIsHubContactRequestStatus: getFetchHubContactRequestStatus(state),
    hasRemoveFromAccountScope: getHasRemoveFromAccountScope(state),
    isScimUser: getIsScimUser(state),
    isHubContact: getIsHubContact(state),
    isHubless: isApplicationHubless(state)
  };
};
const mapDispatchToProps = {
  deleteSelf,
  loadCanGdprDeleteSelf,
  loadIsHubContact,
  removeFromAccount
};
export default connect(mapStateToProps, mapDispatchToProps)(SelfDeletionContainer);